import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Fab, Icon, Typography } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/styles';
import { FuseAnimate } from '@fuse';
import * as Actions from './store/actions';




const ClustersHeader = () => {
	// connecting to redux to specific states
	const mainTheme = useSelector(({ fuse }) => fuse.settings.mainTheme);
	const dispatch = useDispatch();


	return (
		<div className="flex flex-1 w-full mx-40 items-center justify-between">

			<div className="flex flex-1 items-center justify-center px-12">
				<ThemeProvider theme={mainTheme}>
					<FuseAnimate animation="transition.slideLeftIn" items-center w-full delay={300} elevation={1}>
						<Typography className="hidden sm:flex" variant="h6">
							Dashboard
						</Typography>
					</FuseAnimate>
				</ThemeProvider>
			</div>
			<FuseAnimate animation="transition.slideRightIn" delay={300}>
				<Fab
					className="mr-2"
					onClick={() => {
						dispatch(Actions.getDashboard());
					}}
					color="secondary"
					id="refresh-btn"
					size="small"
					aria-label="refresh"
				>
					<Icon>refresh</Icon>
				</Fab>
			</FuseAnimate>
		</div>
	);
};

export default ClustersHeader;
